export const API_KEY = import.meta.env.VITE_VPS_API_KEY || '';

export function getApiUrl(): string {
  // SSR-safe: tanpa window (renderer Node) pakai env atau string kosong —
  // pemanggil server-side wajib oper URL eksplisit bila butuh fetch absolut.
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const url = import.meta.env.VITE_VPS_API_URL || origin;

  if (import.meta.env.PROD && url.includes('localhost')) {
    console.error('[apiConfig] PRODUCTION BUILD using localhost URL! Check .env.production');
  }
  if (typeof window !== 'undefined' && window.location.origin && url !== window.location.origin) {
    console.warn('[apiConfig] Cross-origin request:', url, '(page:', window.location.origin, ')');
  }

  return url.replace(/\/$/, '');
}
